// Sand particle vertex shader — hourglass timer visual
// Particles fall top-to-bottom in an hourglass narrowing pattern

uniform float uTime;

attribute float aSize;
attribute float aOffset;
attribute vec3  aRandom;

varying float vAlpha;
varying float vRandom;

void main() {
    vec3 pos = position;

    // Normalised fall: 0 = top, 1 = bottom
    float t = mod(uTime * 0.30 + aOffset, 1.0);

    // Vertical fall: +1.1 (top) → -1.1 (bottom)
    pos.y = mix(1.1, -1.1, t);

    // Hourglass narrowing: wide at ends, narrow at mid-point
    float hourFactor = sin(t * 3.14159);          // 0 at ends, 1 at middle
    float scatter    = 1.0 - hourFactor * 0.70;   // 1 at ends, 0.30 at neck
    pos.x += aRandom.x * scatter * 0.50;
    pos.z += aRandom.z * scatter * 0.25;

    // Gentle horizontal sway
    pos.x += sin(uTime * 0.9 + aOffset * 6.28) * aRandom.x * 0.035;

    // Alpha: fade in at top, fade out at bottom
    vAlpha  = smoothstep(0.0, 0.07, t) * smoothstep(1.0, 0.93, t);
    vRandom = aRandom.y;

    vec4 mv = modelViewMatrix * vec4(pos, 1.0);
    gl_PointSize = aSize * (200.0 / -mv.z);
    gl_Position  = projectionMatrix * mv;
}
